import React, { useCallback, useEffect, useState } from "react";
import "./Passbook.css";
import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { Link, useParams } from "react-router-dom";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import axios from "axios";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import WithdrawalReceiptModal from "./WithdrawalReceiptModal";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function WithdrawalTransactionDetails() {
  let { transactionid } = useParams();
  // console.log(transactionid);
  const { userID, RendomTokenfetch, profileData } = useAuth();
  const [TransactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Sample transaction data - replace with your actual data
  const FetchTransaction = useCallback(async () => {
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("requestid", transactionid);
    setLoading(true);
    try {
      await axios
        .post(`${WebsiteAPIurl}withdrawaltransactiondetails`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.status === "1") {
            setTransactionData(response.data.WithdrawalDetailData);
          }
          if (response.data.status === "0") {
            setTransactionData([]);
            NotifyMessageNoReload(response.data.message, "danger");
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, transactionid, userID]);

  useEffect(() => {
    FetchTransaction();
  }, [FetchTransaction]);

  const transaction = {
    name: profileData?.username || "",
    email: profileData?.email || "",
    phone: profileData?.number || "",
    address: profileData?.address || "",
    amount: TransactionData?.amount || 0,
    bank_name: TransactionData?.bank_name || "",
    account_holder: TransactionData?.account_holder || "",
    account_number: TransactionData?.account_number || "",
    payment_date: TransactionData?.created_at || "",
    withdrawal_status: TransactionData?.withdrawal_status || "",
    ifsc_code: TransactionData?.ifsc_code || "",
    upiId: TransactionData?.upiId || "",
    requestid: TransactionData?.requestid || "",
    reason: TransactionData?.reason || "",
    paymentmethod: TransactionData?.paymentmethod || "",
    paymentmethodid: TransactionData?.paymentmethodid || "",
  };
  if (loading) {
    return <APIDataFetchLoader />;
  }

  const withdrawal_status = (withdrawal_status) => {
    let showwithdrawal_status;
    let showBordersStyle;
    let showTextStyle;
    if (withdrawal_status === "1") {
      showwithdrawal_status = <span className="badge bg-success">Success</span>;
      showBordersStyle = "border-success";
      showTextStyle = "text-success";
    } else if (withdrawal_status === "2") {
      showwithdrawal_status = <span className="badge bg-info">Inprogress</span>;
      showBordersStyle = "border-info";
      showTextStyle = "text-info";
    } else {
      showwithdrawal_status = <span className=" badge bg-danger">Failed</span>;
      showBordersStyle = "border-danger";
      showTextStyle = "text-danger";
    }

    return { showwithdrawal_status, showBordersStyle, showTextStyle };
  };

  const { showwithdrawal_status, showBordersStyle, showTextStyle } =
    withdrawal_status(transaction.withdrawal_status);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Passbook", pagelink: "passbook" },
            { name: "Withdrawal Amount", pagelink: "withdrawal-amount" },
            { name: "Withdrawal Transaction Details" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer walletDetails">
            <div
              className="newspapermultyupdatebox"
              style={{ borderBottom: "unset" }}
            >
              <div className="row my-1">
                <div className="col-lg-12 col-md-12  mt-1">
                  <Link
                    to="/withdrawal-amount"
                    className="DefaultHoverbtn handleServiceStatus"
                  >
                    <span>
                      <i className="fa fa-arrow-left me-2"></i>
                    </span>{" "}
                    Back
                  </Link>
                </div>
              </div>
            </div>

            <div
              className={`transaction_header p-4 mb-4 border border-success  ${showBordersStyle}`}
              style={{ maxWidth: "920px", backgroundColor: "rgb(229 229 229)" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="">
                  <h4 className="mb-1 text-dark fw-600">Withdrawal </h4>
                  <p className="mb-0 text-dark">
                    Completed on {transaction.payment_date}
                  </p>
                </div>
                <div className="text-md-end">
                  <h3 className="text-light mb-0">
                    {/* ₹{transaction.amount} */}
                    <span className={` ${showTextStyle}`}>
                      {`₹${transaction.amount}`}
                    </span>
                  </h3>
                  {showwithdrawal_status}
                </div>
              </div>
            </div>
            <div className="payment-container" style={{ maxWidth: "920px" }}>
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  {/* <div className="divider"></div> */}

                  <div className="details-section">
                    <h3>
                      <i className="fa fa-info-circle me-2"></i>Withdrawal
                      Details
                    </h3>

                    <table className="details-table">
                      <tbody>
                        <tr>
                          <td className="label">Request ID</td>
                          <td>{transaction.requestid}</td>
                        </tr>
                        <tr>
                          <td className="label">Payment Date</td>
                          <td>{transaction.payment_date}</td>
                        </tr>
                        <tr>
                          <td className="label">Status</td>
                          <td>{showwithdrawal_status}</td>
                        </tr>
                        {transaction.paymentmethod && (
                          <tr>
                            <td className="label">Payment Method</td>
                            <td>
                              <span className="">
                                {transaction.paymentmethod}
                              </span>
                            </td>
                          </tr>
                        )}

                        {transaction.paymentmethodid === "1" ? (
                          <>
                            <tr>
                              <td className="label">Bank Name</td>
                              <td>{transaction.bank_name}</td>
                            </tr>
                            <tr>
                              <td className="label">Account Holder Name</td>
                              <td>{transaction.account_holder}</td>
                            </tr>
                            <tr>
                              <td className="label">Account Number</td>
                              <td>{transaction.account_number}</td>
                            </tr>
                            <tr>
                              <td className="label">IFSC code</td>
                              <td>{transaction.ifsc_code}</td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td className="label">UPI ID</td>
                            <td>{transaction.upiId}</td>
                          </tr>
                        )}

                        {transaction.reason && (
                          <tr>
                            <td className="label">Reason</td>
                            <td>{transaction.reason}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="divider"></div>
                <div className="col-xl-12 col-lg-12 col-md-12 text-center">
                  <div>
                    <button
                      className="theme-btn btn-style-three submitbtn"
                      style={{ marginRight: "12px" }}
                      onClick={() => setShowModal(true)}
                    >
                      <i className="fa fa-download mx-2" aria-hidden="true"></i>{" "}
                      Download Receipt
                    </button>
                    <WithdrawalReceiptModal
                      show={showModal}
                      onClose={() => setShowModal(false)}
                      transaction={transaction}
                      showwithdrawal_status={showwithdrawal_status}
                      showBordersStyle={showBordersStyle}
                      showTextStyle={showTextStyle}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
